// src/components/Dealer/EditDealerModal.js
import React, { useEffect } from 'react';
import { Modal, Form, Input, Button, Spin } from 'antd';

const EditDealerModal = ({ dealer, onSave, onCancel, visible, loading }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        name: dealer.name
      });
    }
  }, [visible, dealer, form]);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      onSave(dealer.id, values);
    }).catch((info) => {
      console.log('Validate Failed:', info);
    });
  };

  return (
    <Modal
      visible={visible}
      title={`Edit Dealer - ID: ${dealer.id}`}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} danger disabled={loading}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit} loading={loading}>
          Save
        </Button>,
      ]}
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: 'Please input the name!' }]}
          >
            <Input disabled={loading} />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default EditDealerModal;